import classNames from 'classnames';
import styles from './dynamic-text.module.scss';

export const DynamicTextButton = ({
  label,
  isSelected,
  onClick,
  icon,
}: {
  label: string;
  isSelected: boolean;
  onClick: () => void;
  icon: React.ReactNode;
}) => {
  return (
    <button
      type="button"
      aria-label={label}
      className={classNames(styles.dynamicTextButton, {
        [styles.isSelected]: isSelected,
      })}
      onClick={onClick}
    >
      {icon}
    </button>
  );
};
